import flatten from 'flat';
import connection from './en-US/connection';

export default flatten({
  ...connection,
});
